import { langRouteI18n } from '@bcf-v2/routes/common/app/i18n/lang-route-i18n';
import { lotteryRouteI18n } from '../i18n/lottery-route-i18n';

export function lotteryRoutePath(): string {
  return `/${langRouteI18n()}/${lotteryRouteI18n()}`;
}
